module.exports = __webpack_public_path__ + "static/media/server.cabc2575.svg";